import { Getter, State, Action, Mutation } from 'vuex-class'
import { Component } from 'vue-property-decorator'
import BasePage from '@/views/BasePage/BasePage'

import Footer from '@/components/footer/footer'
import commerceBanner from '@/components/commerceBanner/commerceBanner'
import category from '@/components/commerceCategory/commerceCategory'
import commerceAlertCart from '@/components/commerceAlertCart/commerceAlertCart'
import SkeletonList from '@/components/skeletonList/skeletonList'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import { configService } from '@/settings/api-url'
import ProductsBtn from '@/components/productsBtn/productsBtn'
import supportBtn from '@/components/supportBtn/supportBtn'
import RecentProduct from '@/components/recentProduct/recentProduct'
import product from '@/components/commerceProduct/commerceProduct'
import SuperCategoriesScrollMenu from '@/components/superCategoriesScrollMenu/superCategoriesScrollMenu'

import SuperCategories from '@/components/superCategories/superCategories'

@Component({
  components: {
    Footer,
    category,
    commerceBanner,
    commerceAlertCart,
    SkeletonList,
    SkeletonFluid,
    ProductsBtn,
    RecentProduct,
    SuperCategories,
    product,
    SuperCategoriesScrollMenu,
    supportBtn
  }
})
export default class CommerceProducts extends BasePage {
  @Action action_getRecents;

  @Getter getCountry
  @Getter getCartTemporal: any
  @Getter getCity: any
  @Getter getUser: any
  @Getter getIsUnderMobile: any


  productsViewed = []
  productsBought = []
  recentsLoaded = false
  categoriesRecetas = [
    {name: 'Todas'},
    {name: 'Oriental'}
  ]

  /* Supercategoríes */
  superCategories       = []
  superCategoriesParsed = []
  superCategoryId       = null
  superCategorySelected = {}

  /* Categoríes */
  categories            = []
  categoryIndex         = 0

  /* Show and modals*/
  close = ''
  isShowCartClear = false
  toggleCar = false
  isReady = false

  /* recent Prodcuts*/
  recentsProducts = []

  async mounted() {
    this._getRecents()


    this._getSuperCategories()
    this.superCategoriesParsed = this.superCategories.map((category) => {
      return {
        id:           category.id,
        bannerUrl: category && category.banners && category.banners[0] && category.banners[0].url,
        name:         category.name,
        pictureUrl:   category.super_category_picture.url
      }
    });

    this.isReady = true;
  }

  // principals
  async _getRecents() {
    let recents = await this.action_getRecents()

    if(recents) {
      this.productsBought = recents.products_bought
      this.productsViewed = recents.products_viewed
    }
    this.recentsLoaded = true;
  }

  _goToIngredients(supercategory) {
    this.$router.push({
      name: 'city',
      params: {
        id: this.getCity.commercial_name as any
      },
      query: {
        category: supercategory
      }
    })
  }

  // Super categories
  _getSuperCategories() {
    let categories = this.getCity && this.getCity.super_categories && this.getCity.super_categories.sort((a, b) => a.ordinal - b.ordinal)

    if(categories) {
      this.superCategories = categories.filter((item) => item.is_active)
    } else {
      this.superCategories = [];
    }
  }

  async _updateSuperCategory(item) {
    this.superCategoryId = item.id;
    this._getCategories(item.id)
    this.superCategorySelected = item
    this.categoryIndex = 0 // reset position of index category

    this._goToIngredients(item.name)
  }

  /* Categories */
  async _getCategories(idCategory) {
    this.categories = [] // Clear categories

    const res = await configService(`/normal_user/commerces/${this.getCity.id}/super_categories/${idCategory}/`)
    if(res) {
      let categories = res.data.categories.sort((a, b) => a.ordinal - b.ordinal)
      categories = categories.filter((element) => {
        return element.is_active && !element.is_deleted
      })

      for (let categorie of categories) {
        categorie.products = categorie.products.filter((element) => {
          return element.is_activated && !element.is_deleted
        })
      }
      this.categories = categories
    }
  }

  goToCategory(category) {
    this.$router.push({ name: 'superCategories', query: { category: category.name }});
  }
}
